import { FiCheckCircle } from "react-icons/fi";
import Header from "../Header";
import Footer from "../Footer";

const SuccessPage = ({ message }) => {
  return (
    <>
      <Header />
      <div className="success-page">
        <div className="success-message">
          <FiCheckCircle style={{ color: "green", fontSize: "40px" }} />
        </div>
        <div className="success-message2">{message}</div>
        <h4>
          Back to <a href="/">Home</a>
        </h4>
      </div>
      <Footer />
    </>
  );
};

export default SuccessPage;
